/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalUserReactionsEmojiResponseV3Emoji interface.
 */
export function instanceOfInternalUserReactionsEmojiResponseV3Emoji(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('unicode' in value) || value['unicode'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiResponseV3EmojiFromJSON(json) {
    return InternalUserReactionsEmojiResponseV3EmojiFromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseV3EmojiFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'unicode': json['unicode'],
    };
}
export function InternalUserReactionsEmojiResponseV3EmojiToJSON(json) {
    return InternalUserReactionsEmojiResponseV3EmojiToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseV3EmojiToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'unicode': value['unicode'],
    };
}
